import { render, staticRenderFns } from "./_sboMatch.vue?vue&type=template&id=6fa48778&scoped=true&lang=pug&"
import script from "./_sboMatch.vue?vue&type=script&lang=js&"
export * from "./_sboMatch.vue?vue&type=script&lang=js&"
import style0 from "./_sboMatch.vue?vue&type=style&index=0&id=6fa48778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa48778",
  null
  
)

export default component.exports